import React from 'react';

import Table from '../../components/Releases/Table/Table';

function ReleasesView() {
  return <Table />;
}

export default ReleasesView;
